export const formatSeconds = (seconds: number, millis?: boolean) => {
  if (isNaN(seconds) || !seconds) {
    return `00:00${millis ? '.00' : ''}`;
  }
  return new Date(seconds * 1000)
    .toISOString()
    .substr(14, millis ? 8 : 5)
};
